jQuery(document).ready(function ($) {
    $('.homeHero .blockFlex .btn').each(function() {
        $(this).parent().addClass('homeHero__buttonWrapper');
    });

    $('.textOverImage__inner .btn').each(function() {
        $(this).parent().addClass('textOverImage__buttonWrapper');
    });
});